import React, { useState, useEffect } from "react";
import Select from "react-select";
import VehicleCategoryServices from "services/VehicleCategoryServices";

const SelectMultipleVehicleCategoryAirport = ({
  register,
  name,
  label,
  selectedVehicle,
  handleVehicleChange,
}) => {
  const [allVehicleCategory, setVehicleCategory] = useState([]);
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      border: "1px",
      boxShadow: "none",
      backgroundColor: "RRGGBB",
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected
        ? "#0e9f6e"
        : state.isFocused
        ? "rgba(0, 0, 0, 0.15)"
        : "white",
      color: state.isSelected ? "white" : state.onClick ? "green" : "black",
      "&:hover": {
        background: "rgba(0, 0, 0, 0.15)", // Change the background color on hover
        color: "black", // Change the text color on hover
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      margin: "10px 0 -10px 0", // Add margin to the entire option box
    }),
    indicatorSeparator: () => ({
      display: "none", // Keeps it clean by removing the separator
    }),
  };
  useEffect(() => {
    async function fetchVehicleCategory() {
      try {
        const response = await VehicleCategoryServices.getAllVehicleCategory();
        const transformedData = response.data.map((item) => ({
          value: item.id,
          label: item.vehicle_type_name,
        }));
        setVehicleCategory(transformedData);
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    }

    fetchVehicleCategory();
  }, []);
  const handleVehicleSelect = async (selected) => {
    handleVehicleChange(selected);
  };

  return (
    <Select
      isMulti
      className=" dark:text-white-300 leading-5 rounded-md  dark:border-gray-600 focus:ring focus:ring-green-300 dark:focus:border-gray-500 dark:focus:ring-gray-300 border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      isSearchable={true}
      {...register(`${name}`, {
        required: !selectedVehicle?.length ? `${label} is required!` : false,
      })}
      name={name}
      styles={customSelectStyles}
      options={allVehicleCategory}
      onChange={(e) => handleVehicleSelect(e)}
      value={selectedVehicle}
    />
  );
};

export default SelectMultipleVehicleCategoryAirport;